import type { Translation } from '../types.ts';
import type en from '../en/transfer.ts';

export default {
    card: {
        title: 'Export voor verhuizing',
        intro: 'Een pakket voor een klant die naar een andere aanbieder verhuist: de website en de gegevens in één zip. Het maken kan bij een grote site even duren. Een klaar pakket is 7 dagen te downloaden en wordt daarna verwijderd.',
        introAdmin: 'Verhuis je deze website naar een andere aanbieder, dan maken wij dit pakket voor je: de website en de gegevens in één zip. Een klaar pakket is hier 7 dagen te downloaden en wordt daarna verwijderd.',
        contents: {
            site: 'een statische HTML-kopie van de openbare website die op elke host kan worden gezet. Formulieren, winkelwagen, afrekenen, klantaccounts en zoeken werken daarin niet.',
            theme: 'de broncode van het thema.',
            data: 'klanten, adressen, bestellingen, bestelregels, nieuwsbriefabonnees, formulierinzendingen met hun bijlagen, en de producten als Shopify-compatibele CSV met hun afbeeldingen.',
            readme: 'legt uit wat er in het pakket zit.',
        },
        personalData: 'Het pakket bevat persoonsgegevens. Na de overdracht is de klant daarvan de verwerkingsverantwoordelijke, dus geef het alleen aan de klant van wie deze website is.',
        create: 'Export maken',
        busy: 'Er wordt een export gemaakt. Een nieuwe kan pas als deze klaar is.',
        empty: 'Nog geen exports.',
        columns: {
            requestedBy: 'Aangevraagd door',
            size: 'Grootte',
            expires: 'Verloopt',
        },
        expired: 'verlopen',
        confirmDelete: 'Verwijderen?',
        deleteExport: 'Export verwijderen',
        failedNoReason: 'De export is mislukt zonder opgave van reden.',
    },
    status: {
        queued: 'in wachtrij',
        running: 'bezig',
        done: 'klaar',
        failed: 'mislukt',
    },
    createDialog: {
        title: 'Export voor verhuizing maken?',
        crawl: 'Hiervoor wordt de live website doorlopen om de statische kopie te maken. Bij een grote site kan dat even duren.',
        personalData: 'Ook de klanten, bestellingen, nieuwsbriefabonnees en formulierinzendingen van de website gaan in het pakket. Dat zijn persoonsgegevens: geef de download alleen aan de klant van wie ze zijn.',
    },
} satisfies Translation<typeof en>;
